// Small sync indicator that lives in the sidebar.

import { el, clear } from './dom.js';

const LABELS = {
  idle:                 { dot: '·',  text: 'Local only',  color: 'var(--muted-2)' },
  offline:              { dot: '⊘',  text: 'Offline',      color: 'var(--muted-2)' },
  syncing:              { dot: '⟳',  text: 'Syncing…',     color: 'var(--accent)' },
  synced:               { dot: '✓',  text: 'Synced',       color: 'var(--ok)' },
  conflict:             { dot: '⚠',  text: 'Conflict',     color: 'var(--warn)' },
  'first-sync-required':{ dot: '↓',  text: 'Cloud Safe',   color: 'var(--warn)' },
  // The remote vault is gone on a device that has synced before. We refuse to
  // auto-republish (that could stomp another device's newer data), so this is
  // a distinct state the user has to resolve, not a transient error.
  'remote-missing':     { dot: '⚠',  text: 'Cloud Safe missing', color: 'var(--warn)' },
  error:                { dot: '✗',  text: 'Sync error',   color: 'var(--danger)' },
};

export function renderSyncStatus(container, { status, onClick }) {
  clear(container);
  const info = LABELS[status] ?? LABELS.idle;
  const node = el('button', {
    class: 'sync-status',
    style: { color: info.color },
    onclick: onClick,
    title: `Sync status: ${info.text}`,
  }, [
    el('span', { class: 'dot' }, [info.dot]),
    el('span', { class: 'text' }, [info.text]),
  ]);
  container.append(node);
}
